import axios from 'axios'
import { CADASTRAR_ITINERARIO_POR_PERIODO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarItinerarioPorPeriodo (parametros) {
  const url = `${URL}/itinerario/cadastrar-por-periodo`;
  return dispatch => axios.post(url, parametros, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_ITINERARIO_POR_PERIODO,
        payload: response
      })
  );
}
